import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import { EditTable } from '../../../organisms'
import AdminLayoutIndex from '../_layouts'

declare var window: interfaces.IWindow

interface IProps {
  promotions: {
    promotions: IJsonResponse
  }
}

const COLUMNS = [
  {
    name: I18n.t('generic.id'),
    field: 'id',
    required: false,
    readOnly: true,
  },
  {
    name: I18n.t('generic.code'),
    field: 'code',
    required: true,
  },
  {
    name: I18n.t('generic.comment'),
    field: 'comment',
    required: false,
  },
]

const AdminPromotionIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Admin promotion')
  const { data, pagination } = adminService.getDataFromJson(props.promotions.promotions)
  const [promotions, setPromotions] = React.useState(data)
  const handleDelete = React.useCallback(
    async id => {
      const { flush } = await adminService.deletePromotion(id)
      window.flashMessages.addMessage({
        text: flush.message,
        type: flush.type,
      })
      setPromotions(promotions.filter(promotion => promotion.id !== id))
    },
    [promotions]
  )

  const handleClickDelete = id => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(id)
    }
  }

  return (
    <AdminLayoutIndex
      model="promotion"
      title={
        <Heading>
          <span>{I18n.t('generic.promotions')}</span>
          <Button small={true}>
            <a href="/admin/promotions/new">{I18n.t('generic.create_new')}</a>
          </Button>
          <Button small={true}>
            <a href="/admin/promotions/statistics_report">{I18n.t('admin.statistical_reports')}</a>
          </Button>
        </Heading>
      }
      main={
        <EditTable
          editable={true}
          columns={COLUMNS}
          records={promotions}
          pagination={pagination}
          handleDelete={handleClickDelete}
          getEditLink={({ id }) => `/admin/promotions/${id}/edit`}
        />
      }
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

export default AdminPromotionIndex
